module.exports = __webpack_public_path__ + "img/perforaciones_3-4.26d9a71d.jpg";